import { render, staticRenderFns } from "./Firing.vue?vue&type=template&id=2124c1b2"
import script from "./Firing.vue?vue&type=script&lang=js"
export * from "./Firing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports